import ApplicationController from '../application_controller'

export default class extends ApplicationController {
  static values = {
    code: String,
    url: String,
  }

  static targets = ['codeInput']

  submit(event) {
    const { value: newCountryCode } = event.target

    if(this.hasCodeInputTarget) {
      this.codeInputTarget.value = newCountryCode
    } else {
      this.element.setAttribute('action', this.urlValue.replace(':code', newCountryCode))
    }

    this.element.requestSubmit()
  }
}
